// extracted by mini-css-extract-plugin
export var contentfulAsset = "_09NNu";